import ReactSelect from 'react-select';
import { dropdownColors } from 'app/colors';
import styled from '@emotion/styled';
import { textCss } from 'app/typography';
import { reactSelectStyles, StyledCustomOption } from './Select/styles';

const getTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: dropdownColors.hover,
  },
});

const getValue = (value, options) => {
  // if the value is a string, find that in the options and return it
  if (typeof value === 'string') {
    return options.find((option) => option.value === value);
  }

  // if the value is an object, key off of the id
  if (value && 'id' in value) {
    return options.find((option) => option.value.id === value.id);
  }

  return value;
};

const StyledSelect = styled(ReactSelect)`
  width: 100px;
  display: inline-block;
  .Select__control {
    border: none;
    box-shadow: none;
    min-height: 0;
    padding-bottom: 1px;
    background-color: transparent;
    background-image: repeating-linear-gradient(
      to right,
      var(--color-border-dark) 0 5px,
      transparent 5px 10px
    );
    background-size: 100% 1px;
    background-position: left bottom;
    background-repeat: no-repeat;
    &:hover {
      background-image: repeating-linear-gradient(
        to right,
        var(--color-button-secondary-hover) 0 5px,
        transparent 5px 10px
      );
    }
    &--is-focused {
      background-image: linear-gradient(
        var(--color-button-secondary-hover),
        var(--color-button-secondary-hover)
      );
      &:hover {
        background-image: linear-gradient(
          var(--color-button-secondary-hover),
          var(--color-button-secondary-hover)
        );
      }
    }
  }
  .Select__indicator {
    padding: 0;
    padding-left: 8px;
    color: var(--color-button-secondary-default);
    &:hover {
      color: var(--color-button-secondary-hover);
    }
    // Align indicator icon with right side
    overflow: hidden;
    > :first-child {
      margin-right: -3px;
    }
  }
  .Select__value-container {
    // Align value with left side
    padding-left: 0;
  }

  .Select__single-value,
  .Select__input {
    ${textCss()}
  }
  .Select__menu {
    margin-bottom: 1px; // Room to see bottom border when at bottom of scroll container
  }
`;

const editableReactSelectStyles = {
  menu: reactSelectStyles.menu,
  menuList: reactSelectStyles.menuList,
  option: reactSelectStyles.option,
  indicatorSeparator: reactSelectStyles.indicatorSeparator,
};

export default function EditableSelect({ value = null, options, ...others }) {
  return (
    <StyledSelect
      classNamePrefix="Select"
      theme={getTheme}
      value={getValue(value, options)}
      options={options}
      styles={editableReactSelectStyles}
      components={{ Option: StyledCustomOption }}
      {...others}
    />
  );
}
